import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";

export class ChangeOddsHandler extends ActionHandler {
  type = ACTION_TYPES.oddsChange;
  localStorageUtils: LocalStorageUtils;

  static injectables = [LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  async action(params) {
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.oddsType, params.oddsType);
    this.appStore.setSelectedOddsType(params.oddsType);
  }
}
